module.exports = __webpack_public_path__ + "img/Warlock-bloodelf-f-70.c8f3c4bf.gif";